export const APP_NAVIGATION_REQUEST_EVENT = "econ-pulse:navigation-request";

export interface NavigationRequestDetail {
  href: string;
}

export function requestAppNavigation(href: string): boolean {
  const event = new CustomEvent<NavigationRequestDetail>(
    APP_NAVIGATION_REQUEST_EVENT,
    {
      cancelable: true,
      detail: { href },
    },
  );
  window.dispatchEvent(event);
  return !event.defaultPrevented;
}
